module.exports = __webpack_public_path__ + "img/logo.7ea0e4d4.svg";